module.exports = __webpack_public_path__ + "fe745621accdcdc089b150718860c50e.png";